<template>
  <div class="public_head">
    <el-container>
      <!-- 头部导航栏 -->
      <el-header>
        <div class="demo-image">
          <img :src="idLogo" alt/>
        </div>
        <div class="demo-wenzi">
           <img src="../assets/sebei.png" alt/>
        </div>
        <div class="right" @click="toggle">
           <div class="item hover-effect">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="dp el-dropdown-link">
                <div class="iconfont">
                  <svg-icon icon-class="guanliyuan" style="font-size: 35px"></svg-icon>
                </div>
                <div class>{{username}}</div>
              </div>
              <el-dropdown-menu slot="dropdown" class="dropdown-user">
                <el-dropdown-item command="1" >退 出 登 录</el-dropdown-item>
                <el-dropdown-item command="2" >修 改 密 码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="item hover-effect" style="margin-right: 0px">
            <el-dropdown trigger="click" @command="handleChangeTheme">
              <div class="dp el-dropdown-link" style="margin-right: 0px">
                <div class="iconfont" style="">
                  <svg-icon icon-class="gengduo" style="font-size: 20px"></svg-icon>
                </div>

              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="theme2">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="chuantonghei" style="font-size: 18px;margin-right: 5px;"></svg-icon>
                    传统黑
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="theme1">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="keji" style="font-size: 22px;margin-left: -3px;margin-right: 5px"></svg-icon>
                    科技蓝
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="theme2_skyblue">
                  <div style="display: flex;align-items: center">
                    <svg-icon icon-class="baicai" style="font-size: 14px;margin-left: 0px;margin-right: 10px"></svg-icon>
                    极光白
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div> 
      </el-header>
    </el-container>
    <change-password ref="changePass"></change-password>
  </div>
</template>
<style lang="scss" scoped>

  .headColor {

    [data-theme="theme1"] & {
      width: 100%;
      height: 3px;
      background: linear-gradient(270deg, rgba(0, 255, 245, 0) 0%, rgba(0, 255, 246, 1) 50%, rgba(0, 128, 123, 0) 100%);
    }


  }

  .el-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 57px !important;
    line-height: 57px;
    color: #ffffff;
    background: #001F38;
    // background: linear-gradient(to right, #48D0FF, #1167E9);/*标准语法*/
    // box-shadow:0px 7px 10px rgba(47, 106, 196 ,0.8) ;
    z-index: 2000;
    // background: -webkit-linear-gradient(left, #48D0FF, #1167E9); /* Safari 5.1 - 6.0 */
    // background: -o-linear-gradient(right,#48D0FF, #1167E9); /* Opera 11.1 - 12.0 */
    // background: -moz-linear-gradient(right, #48D0FF, #1167E9); /* Firefox 3.6 - 15 */
  }

  [data-theme="theme2_skyblue"]
  .el-header{
    background: linear-gradient(to left,rgb(72, 173, 255), #1167E9);
    box-shadow:0px 6px 20px rgba(19,107,234 ,0.5) ;
  }

  .demo-image {
    width: 193px;
    height: 45px;
    margin-top: 4px;
    // [data-theme="theme2"] & {
    //   padding-top:10px;
    // }
  }

  .demo-wenzi {
    height: 35px;
    margin-left: 13px;
  }

  .demo-image img {
    width: 100%;
    height: 100%;
  }

  .demo-wenzi img {
    height: 35px;
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .el-dropdown-link:focus {
    outline: none;
  }

  .right {
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    text-align: right;

    .item {


      margin-right: 20px;
      /*line-height: 60px;*/
      .iconfont {
        height: 57px;
        width: 36px;
        padding-right: 10px;
        display: flex;
        align-items: center;
      }

      .dp {
        line-height: 50px;
        margin-right: 15px;

        [data-theme="theme1"] & {
          color: #00ECE5;
        }

        [data-theme*="theme2"] & {
          color: #fff;
        }


        div {
          float: left;
          line-height: 57px;
          font-size: 16px;
        }
      }
    }

    .hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .twochange {
    width: 150px;
    height: 100px;
    z-index: 1000;
    position: absolute;
    left: 0;
  }

  .change {
    border: 1px solid #cccccc;
    width: 150px;
    height: 25px;
    line-height: 25px;
    background: inherit;
    background-color: rgb(25, 34, 48);

    border-radius: 0px;
    display: block;
    padding: 0;
    color: #ffffff;
    text-align: center;
  }

  .end {
    border-radius: 24px;
    width: 88px;
    height: 32px;
    font-size: 14px;
    line-height: 7px;
    background: rgba(8, 107, 175, 0.99);
    color: rgb(255, 255, 255);
    position: absolute;
    right: -25%;
    border: none;
  }
  // 提醒控制
  .dropdown-user{
    .el-dropdown-menu__item{
      padding: 0 25px!important;
    }
    .alarmTip{
    padding: 0px 10px!important;
   &:before {
      margin: 0 -10px!important;
    }
    .control-btn{
    width: 40px;
    height: 21px;
    float: left;
    line-height: 45px;
    img{
      width: 100%;
      height: 100%;padding-right: 10px;
    }
  }
  }
  }

</style>
<script>
    import router from "../router";
    import {EventBus} from '@/utils/event-bus';
    import {getUserId} from "@/utils/auth";
    import {logout} from "@/services/deviceType";
    import changePassword from './changePassword'
    export default {
      components:{changePassword},
        data() {
            return {
                idLogo:require("../assets/yinliLogo.png"), //require("../assets/fnj002.png"),
                isshow1: false,
                isshow: false,
                username: "",
                dialogVisible: false,
                ruleForm: {
                    pass: "",
                    newPass: "",
                    checkPass: ""
                }
              };
        },
        methods: {
            handleCommand(type) {
                if (type == 1) {
                    this.logOut();
                }else if(type == 2){
                  console.log("222")
                    this.$refs.changePass.openModel()
                }
            },
             handleChangeTheme(theme) {
                window.document.documentElement.setAttribute('data-theme', theme)
                localStorage.setItem("theme", theme);
                this.$store.dispatch('settings/changeSetting', {
                    key: 'theme',
                    value: theme
                })
            },

            toggle() {
                this.isshow = !this.isshow; //取反
            },

            // 退出登录
            async logOut() {
                    sessionStorage.removeItem("token");
                    this.$router.push({path: "/"});
                    window.location.reload(); //清空上一个登录账号的路由信息
                    this.$message.success( "退出登录");
                    // const res=await logout({})
                    // console.log(res,"res")
                    // if(res&&res.code==0){

                    // }
            },
        },
        created() {
            var than = this;
            this.username = sessionStorage.getItem("username");
            let isReceive= localStorage.getItem("is_receive");
        },
        mounted() {

        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Head.vue